import { render, staticRenderFns } from "./returnPayFee.vue?vue&type=template&id=a5646786&scoped=true"
import script from "./returnPayFee.vue?vue&type=script&lang=js"
export * from "./returnPayFee.vue?vue&type=script&lang=js"
import style0 from "./returnPayFee.vue?vue&type=style&index=0&id=a5646786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5646786",
  null
  
)

export default component.exports